// const getEmail = () => process.env.REACT_APP_EMAIL;

import config from "../config";

// export const getWhatsApp = () => process.env.REACT_APP_WHATSAPP;

const getEmail = () => config.REACT_APP_EMAIL;

export const getWhatsApp = () => config.REACT_APP_WHATSAPP;

export default  getEmail;